// extracted by mini-css-extract-plugin
var _1 = "SVpxK";
var _2 = "B5gCT";
export { _1 as "spinner", _2 as "spinnerMessage" }
